import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import { Images } from 'assets/images';
import { BLOCKED_OR_NOT, ROLES } from 'admin/utils/contants';
import {
  ModalWrapper,
  ModalSampleField,
  PasswordWrapper,
  SaveButton,
  StyledSelect,
  CreateUserErrorMessage,
  CloseIcon,
  InputWithLabel,
  PasswordEye,
} from './styled';

export const CreateUserModal = ({ setData, setIsOpen, setCustomerData, _data }) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(true);

  const {
    handleSubmit,
    formState: { errors },
    control,
    register,
  } = useForm();

  const onSubmit = (data) => {
    if (data.role === ROLES.admin || data.role === ROLES.operator) {
      setData((prev) => [
        ...prev,
        {
          id: _data.length + 1,
          name: data.name,
          email: data.email,
          birthdate: data.birthdate,
          blocked: 'no',
          role: data.role,
          request_limit: 4,
        },
      ]);

      setIsOpen(false);
    } else {
      setCustomerData((prev) => [
        ...prev,
        {
          id: _data.length + 1,
          name: data.name,
          email: data.email,
          birthdate: data.birthdate,
          blocked: 'no',
          role: data.role,
          request_limit: 4,
        },
      ]);

      setIsOpen(false);
    }
  };

  const handlePasswordType = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  return (
    <ModalWrapper onSubmit={handleSubmit(onSubmit)}>
      <CloseIcon src={Images.adminCloseIcon} onClick={() => setIsOpen(false)} />
      <ModalSampleField>
        <Controller
          name="name"
          control={control}
          render={({ field }) => (
            <>
              <InputWithLabel
                id="outlined-basic"
                label="Name"
                {...register('name')}
                onChange={field.onChange}
                key={field.key}
                inputProps={{
                  autocomplete: 'new-password',
                  form: {
                    autocomplete: 'off',
                  },
                  className: 'material-ui-textfield',
                }}
                variant="outlined"
              />
            </>
          )}
        />
      </ModalSampleField>

      <ModalSampleField>
        <Controller
          name="email"
          control={control}
          render={({ field }) => (
            <>
              <InputWithLabel
                id="outlined-basic"
                label="Email Address"
                {...register('email')}
                inputProps={{
                  autocomplete: 'new-password',
                  form: {
                    autocomplete: 'off',
                  },
                }}
                onChange={(e) => field.onChange(e)}
                key={field.key}
                variant="outlined"
              />
            </>
          )}
        />
      </ModalSampleField>

      <ModalSampleField>
        <Controller
          control={control}
          name="role"
          render={({ field }) => (
            <Box>
              <FormControl>
                <InputLabel id="demo-simple-select-label">Role</InputLabel>
                <StyledSelect
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Role"
                  onChange={field.onChange}
                  selected={field.value}
                  inputProps={{
                    autocomplete: 'new-password',
                    form: {
                      autocomplete: 'off',
                    },
                  }}
                  options={BLOCKED_OR_NOT}
                  placeholder="Role"
                >
                  <MenuItem value={ROLES.user}>{ROLES.user}</MenuItem>
                  <MenuItem value={ROLES.admin}>{ROLES.admin}</MenuItem>
                  <MenuItem value={ROLES.operator}>{ROLES.operator}</MenuItem>
                </StyledSelect>
              </FormControl>
            </Box>
          )}
        />
        <CreateUserErrorMessage>{errors.role?.message}</CreateUserErrorMessage>
      </ModalSampleField>

      <ModalSampleField>
        <Controller
          name="birthdate"
          control={control}
          render={({ field }) => (
            <InputWithLabel
              type="date"
              id="outlined-basic"
              label="Birth Date"
              defaultValue="2017-05-24"
              InputLabelProps={{
                shrink: true,
              }}
              {...register('birthdate')}
              onChange={(e) => field.onChange(e)}
              key={field.key}
              variant="outlined"
            />
          )}
        />
      </ModalSampleField>

      <ModalSampleField isPassword>
        <Controller
          name="Password"
          control={control}
          rules={{ required: 'Password is required' }}
          render={({ field }) => (
            <PasswordWrapper>
              <PasswordEye
                isPasswordVisible
                src={isPasswordVisible ? Images.eyeClosedSilverEye : Images.eyeIcon}
                onClick={handlePasswordType}
              />
              <InputWithLabel
                id="outlined-basic"
                label="Password"
                type={isPasswordVisible ? 'password' : 'text'}
                key={field.key}
                {...register('password')}
                inputProps={{
                  autocomplete: 'new-password',
                  form: {
                    autocomplete: 'off',
                  },
                }}
                onChange={(e) => field.onChange(e)}
                variant="outlined"
              />
            </PasswordWrapper>
          )}
        />
      </ModalSampleField>
      <ModalSampleField>
        <SaveButton type="submit">Save</SaveButton>
      </ModalSampleField>
    </ModalWrapper>
  );
};
